// MainFile.js
import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  CssBaseline,
  Paper,
  ThemeProvider,
  Typography,
  createTheme,
} from "@mui/material";
import "../Investor/style/InvestorLayout.css";
import MeetingHistory from "../Investor/MeetingHistory.js";
import GeneralUpdate from "../Investor/GeneralDetailUpdate";
import KycDetails from "../Investor/Kyc";
import BankDetail from "../Investor/Bank";
import { MyContext } from "../../MyContext";
import { callApi } from "../../common/api";
import Loader from "../../common/components/Loader";

const InvestorLayout = ({ children }) => {
  const changeButtonStates = (change) => {
    setButtonDisabled(change);
  };
  const [text, setText] = useState("");

  const [showData, setShowData] = useState();


  const handleButtonClick = (name, component) => {
    Object.keys(buttonClicked).map((key) => {
      if (key === name) {
        setButtonClicked((prevButtonClicked) => ({
          ...prevButtonClicked,
          [key]: true, // Update the value of the specified key
        }));
      } else {
        setButtonClicked((prevButtonClicked) => ({
          ...prevButtonClicked,
          [key]: false, // Update the value of the specified key
        }));
      }
    });
    setComponentToShow(component);
  };
  const [componentToShow, setComponentToShow] = useState(
    <MyContext.Provider value={{ text, setText }}>
      <GeneralUpdate
        onDataChange={changeButtonStates}
        onPageChange={handleButtonClick}
      />
    </MyContext.Provider>
  );
  const [content, setContent] = useState({});

  const [buttonDisabled, setButtonDisabled] = useState(true);
  
  const [buttonClicked, setButtonClicked] = useState({
    button1: true,
    button2: false,
    button3: false,
    button4: false,
  });

  async function getAllPersonalData() {
    try {
      const response = await callApi("get", "investor/allInfo");
      if (response.data.response.data) {
        setShowData(response.data.response.data.underProcess)
        return response
      }
    } catch {
    }
  }
  useEffect(() => {
    getAllPersonalData().then((v) => {
      setContent(v);
    })
    setButtonDisabled(false);
  }, []);

  const theme = createTheme();
  const getInitials = (name) => {
    const parts = name.split(" ");
    if (parts.length === 1) {
      return parts[0].charAt(0);
    }
    return parts[0].charAt(0) + parts[1].charAt(0);
  };
  let userName = text;
  return (
    <>
      {!content || Object.keys(content).length === 0 ? <Loader /> :
        <>
          <div id="main" >
            <section className="homepagebanner bg_black" >
              <div className="container">
                <div className="mainvbanner bottomright">
                  <div className="">
                    <div className="row align-items-center">
                      <div className="col-md-12 mb-md-0">
                        <div className="bannertext blogback">
                          <h1 className="mainheads">My Profile</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* </div> */}
            </section>


            <section className="profilepage bg_black commonspace">
              <div className="container">
                <div className="row">

                  <div className="col-lg-3 col-md-3 col-sm-4 col-12">
                    <div className="profileleftbox">
                      <div className="profileleftname">
                        <h3 className="profileNameDiv"><span className="avatarInit">{getInitials(userName)}</span><span className="profileNameSpan">{userName}</span></h3>
                      </div>
                      <div className="profileleft">
                        <h4><a style={{ cursor: "pointer", color: buttonClicked.button1 ? "white" : "#7a7a7a" }} className="active" name="button1" onClick={(e) =>
                          handleButtonClick(
                            "button1",
                            <MyContext.Provider value={{ text, setText }}>
                              <GeneralUpdate onPageChange={handleButtonClick} />
                            </MyContext.Provider>

                          )
                        }>General Detail</a></h4>
                        <h4><a style={{ cursor: "pointer", color: buttonClicked.button2 ? "white" : "#7a7a7a" }} name="button2" onClick={(e) =>
                          handleButtonClick(
                            "button2",
                            <KycDetails onDataChange={handleButtonClick} />
                          )
                        }>KYC</a></h4>
                        <h4><a style={{ cursor: "pointer", color: buttonClicked.button3 ? "white" : "#7a7a7a" }} name="button3" onClick={(e) =>
                          handleButtonClick(
                            "button3",
                            <BankDetail onDataChange={handleButtonClick} />
                          )
                        }>Bank</a></h4>
                        <h4><a style={{ cursor: "pointer", color: buttonClicked.button4 ? "white" : "#7a7a7a" }} onClick={(e) =>
                          handleButtonClick(
                            "button4",
                            <MeetingHistory onDataChange={handleButtonClick} />
                          )
                        }>Meeting History</a></h4>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-9 col-md-9 col-sm-8 col-12">
                    {componentToShow}
                  </div>

                </div>
              </div>

            </section>
          </div>

        </>
      }
    </>
  );
};

export default InvestorLayout;
